var base = require('auth/register-stripe');
import Datepicker      from 'vuejs-datepicker';

Vue.component('spark-register-stripe', {
    mixins: [base],
    components: {
        Datepicker,
    }
});
